import type { Interval } from "date-fns";
import { TripRef } from "./TripRef";

/**
 * Returns an {@link Interval} object from the given trip.
 * @param trip - The trip to get the interval from.
 * @returns - The interval of the trip.
 */
export function tripInterval(trip: Pick<TripRef, "start" | "stop">) {
  return {
    start: trip.start,
    end: trip.stop ?? trip.start,
  } satisfies Interval;
}
